import React, { Fragment } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';

const ShopCard = ({ key, img, productTitle, price, slug , id}) => {

    return (
        <Fragment>
            <Link to={`/product-detail/${slug}`} state={{ id: id }}>
                <Card className='border-0 bg-transparent mb-3 shop-card' key={key}>
                    <Card.Img variant="top" height={"340px"} src={img} style={{ objectFit: "cover" }} />
                    <Card.Body className='p-0 pt-3'>
                        <Card.Title className='mb-0'>{productTitle}</Card.Title>
                        <Card.Text className='text-danger fw-600 s-16'>
                            $ {price}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Link>
        </Fragment>

    );
}

export default ShopCard